import React from "react";
import { Mui, MuiIcons } from "@osu/react-ui";

/**
 * ProgramBenefits - Shows program benefits for scholars invitation in V2
 */
function ProgramBenefits() {
  return (
    <Mui.Box
      sx={{
        backgroundColor: "rgba(25, 118, 210, 0.04)",
        borderRadius: 2,
        p: 3,
        mb: 3,
        border: "1px solid rgba(25, 118, 210, 0.12)",
      }}
    >
      <Mui.Typography
        variant="h6"
        gutterBottom
        sx={{ color: "primary.main", mb: 2 }}
      >
        Program Benefits:
      </Mui.Typography>

      <Mui.Grid container spacing={2} sx={{ mb: 2 }}>
        <Mui.Grid item xs={12} sm={6}>
          <Mui.Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <MuiIcons.Home sx={{ color: "primary.main", mr: 1, fontSize: 18 }} />
            <Mui.Typography variant="body2">
              16 specialized living-learning communities
            </Mui.Typography>
          </Mui.Box>
        </Mui.Grid>

        <Mui.Grid item xs={12} sm={6}>
          <Mui.Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <MuiIcons.Science sx={{ color: "primary.main", mr: 1, fontSize: 18 }} />
            <Mui.Typography variant="body2">
              Focus on academic experiences outside the classroom
            </Mui.Typography>
          </Mui.Box>
        </Mui.Grid>

        <Mui.Grid item xs={12} sm={6}>
          <Mui.Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <MuiIcons.Group sx={{ color: "primary.main", mr: 1, fontSize: 18 }} />
            <Mui.Typography variant="body2">
              Network with peers who share your interests and passions
            </Mui.Typography>
          </Mui.Box>
        </Mui.Grid>

        <Mui.Grid item xs={12} sm={6}>
          <Mui.Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <MuiIcons.EmojiEvents sx={{ color: "warning.main", mr: 1, fontSize: 18 }} />
            <Mui.Typography variant="body2" sx={{ fontWeight: 500 }}>
              Bonus: Apply to Honors after first semester
            </Mui.Typography>
          </Mui.Box>
        </Mui.Grid>
      </Mui.Grid>
    </Mui.Box>
  );
}

export default ProgramBenefits;